import * as builtinTasks from './configs';
import * as type from '@xfe-team/utils/src/type-utils';

export default function initialize(clientTasks = {}) {
  const availableKeys = Object.keys(builtinTasks).filter(key => {
    const builtinTask = builtinTasks[key];
    const clientTask = clientTasks[key];
    let { enable = true } = builtinTask;
    if (!type.isNullOrUndefined(clientTask)) {
      enable = clientTask;
    }
    return enable;
  });

  availableKeys.forEach(key => {
    const task = builtinTasks[key];
    task.run();
  });
}
